import { Button, Divider, Form, Image, Input, Select } from "antd";
import { useBTSConfigs } from "./BTSStore";
import { useForm } from "antd/es/form/Form";
import { MAIN_URL } from "../../../Constants";
import { useEffect } from "react";

export default function Edit() {
    const [form] = useForm()
    let {ed, packages, post_types, updateBTSConfig} = useBTSConfigs()

    useEffect(() => {
        form.setFieldsValue(ed)
    }, [ed])
    
    return (
        <div>
            <Image
                width={150}
                src={MAIN_URL + '/' + ed?.img}
            />
            <div>
                <b>Nomi:</b> {ed?.product_name}
                <br />
                <b>Kategoriyasi:</b> {ed?.category_name}
                <br />
                <b>Qo'shimcha parametr:</b> {ed?.parametr}
                <br />
                <b>Davlat:</b> {ed?.country_name}
                <br />
                <b>Ishlab chiqaruvchi:</b> {ed?.manufacturer_name}
            </div>
            <Divider />
            <h3>BTS parametrlari</h3>
            <Form form={form} layout="vertical" onFinish={updateBTSConfig}>
                <Form.Item name={'id'} hidden>
                    <Input />
                </Form.Item>
                <Form.Item name={'volume'} label="Og'irligi (kg)">
                    <Input type="number" />
                </Form.Item>
                {/* <Form.Item name={'weight'} label="Gabariti (sm3 balandlik * eni * bo'yi)">
                    <Input />
                </Form.Item> */}
                <Form.Item name={'packageId'} label="Qadoq turi">
                    <Select options={packages.map(p => ({ label: p.nameuz, value: p.id }))}/>
                </Form.Item>
                <Form.Item name={'postTypeId'} label="Shakli">
                    <Select options={post_types.map(p => ({ label: p.nameuz, value: p.id }))}/>
                </Form.Item>
                <Form.Item>
                    <Button type="primary" htmlType="submit">Saqlash</Button>
                </Form.Item>
            </Form>
        </div>
    )
}